import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useScrollToAnchor(isReady: boolean) {
  const { hash } = useLocation();

  useEffect(() => {
    if (!isReady || !hash) return;

    const element = document.getElementById(hash.slice(1));

    if (!element) return;

    element.scrollIntoView({ behavior: "smooth" });
  }, [isReady, hash]);
}
